import React from 'react';
import SectionCard from '../components/SectionCard';
import ActionItem from '../components/ActionItem';

export default function ActionsSection({ actions = [] }) {
  if (!actions || actions.length === 0) return null;
  return (
    <SectionCard title="🎯 Actions prioritaires">
      <div style={styles.list}>
        {actions.map((insight, idx) => (
          <ActionItem key={`${insight.category || 'a'}-${idx}`} index={idx + 1} insight={insight} />
        ))}
      </div>
      <p style={styles.note}>Recommandations générées par Claude Haiku 4.5</p>
    </SectionCard>
  );
}

const styles = {
  list: {
    display: 'flex',
    flexDirection: 'column',
  },
  note: {
    margin: '8px 0 0',
    fontSize: 11,
    color: '#9A9A9A',
    fontStyle: 'italic',
  },
};
